import React, { Component } from 'react';
import Content from '../../components/Content';

class ZaNas extends Component {
  componentDidMount() {
    document.title = 'За нас - A1 Xplore TV GO';
  }

  render() {
    return <Content resource="ZaNas" />;
  }
}

export default ZaNas;
